export const convertDate: (date: Date) => string = (date: Date, reverse?: boolean) => {
  if(reverse) {
    return date.toISOString().substr(0, 10).split('-').reverse().join('-');
  }
  return date.toISOString().substr(0, 10);
}
